















































import { Component, Vue } from 'vue-property-decorator'
import SongRequest from '@/types/SongRequest'
import { namespace } from 'vuex-class'
import VButton from '@/components/miniComponents/VButton.vue'
import APIClient from '@/API/APIClient'

const partyRoomModule = namespace('partyRoom')
const userModule = namespace('user')

@Component({
  components: { VButton }
})
export default class SongDisplay extends Vue {
  @partyRoomModule.Getter('firstSong') currentSong!: SongRequest
  @partyRoomModule.Getter('votesForNextSong') votesForNextSong!: Array<string>
  @partyRoomModule.Getter('partyID') partyID!: string
  @partyRoomModule.Getter('playingPlaylist') playingPlaylist!: boolean
  @userModule.Getter('userID') userID!: string

  get hasVotedForNext (): boolean {
    return this.votesForNextSong ? this.votesForNextSong.includes(this.userID) : false
  }

  voteForNextSong () {
    try {
      APIClient.PartyRoom.voteForNextSong(this.partyID, this.userID)
    } catch (e) {
      console.log(e)
    }
  }
}
